// src/hooks/useAuthSync.js
import { useEffect } from 'react';
import useAuthStore from '../store/authStore';

const useAuthSync = () => {
  useEffect(() => {
    const syncAuth = (e) => {
      if (e.key === "token") {
        if (e.newValue) {
          // Token was added in another tab, re-initialize auth
          useAuthStore.getState().initializeAuth();
        } else {
          // Token removed, log out
          useAuthStore.getState().logout();
        }
      }
    };

    window.addEventListener("storage", syncAuth);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("storage", syncAuth);
    };
  }, []);
};

export default useAuthSync;
